import PropType from 'prop-types';

const CloseDayToast = (props) => {
  const {
    setShowToast,
    setClosedCloseDayToast,
    setShowCloseDayModal,
    setCloseModalType,
  } = props;

  const handleCloseToast = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setClosedCloseDayToast(true);
    setShowToast(false);
  };

  const handleOpenModal = (e) => {
    e.preventDefault();
    setClosedCloseDayToast(true);
    setShowCloseDayModal(true);
    setCloseModalType('closeDay');
    setShowToast(false);
  };

  return (
    <div
      id="toast-warning"
      className="flex items-center w-full max-w-md p-4 text-gray-500 bg-white rounded-lg shadow-lg fixed bottom-5 right-5"
      role="alert"
      onClick={handleOpenModal}
    >
      <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-orange-500 bg-orange-100 rounded-lg dark:bg-orange-700 dark:text-orange-200">
        <svg
          className="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
        </svg>
        <span className="sr-only">Warning icon</span>
      </div>
      <div className="ms-3 text-sm font-normal">
        Recuerda realizar el cierre de caja antes de salir de la app.
      </div>
      <button
        type="button"
        className="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8"
        data-dismiss-target="#toast-warning"
        onClick={handleCloseToast}
        aria-label="Close"
      >
        <span className="sr-only">Close</span>
        <svg
          className="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
      </button>
    </div>
  );
};

CloseDayToast.propTypes = {
  setShowToast: PropType.func,
  setClosedCloseDayToast: PropType.func,
  setShowCloseDayModal: PropType.func,
  setCloseModalType: PropType.func,
};

export default CloseDayToast;
